import WebLayout from './BadgeLayout.web'
import MobileLayout from './BadgeLayout.mobile'
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
